import React from 'react';
import PromotionAnimation from './PromotionAnimation';
import Enroll from './Enroll';

const Promotion = () => {
    return (
        <div className='promotion_wrapper'>
            <div className='container'>
                <PromotionAnimation />
                <Enroll />
            </div>
        </div>
    );
}

export default Promotion;
